module.exports = __webpack_public_path__ + "media/67.f42d0da7.mp3";